import React, { useCallback, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/index.css';

interface MobileMenuProps {
    isMenuOpen: boolean;
    toggleMenu: () => void;
    handleLinkClick: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isMenuOpen, toggleMenu, handleLinkClick }) => {
    const menuRef = useRef<HTMLDivElement>(null);

    const handleMenuToggle = useCallback(() => {
        toggleMenu();
    }, [toggleMenu]);

    const handleLinkClickCallback = useCallback(() => {
        handleLinkClick();
    }, [handleLinkClick]);

    const handleClickOutside = useCallback((event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            toggleMenu();
        }
    }, [toggleMenu]);

    useEffect(() => {
        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen, handleClickOutside]);

    return (
        <div className="mobile-menu" ref={menuRef}>
            <button onClick={handleMenuToggle} className="menu-toggle">
                <span></span>
                <span></span>
                <span></span>
            </button>
            {isMenuOpen && (
                <nav className="mobile-nav">
                    <ul>
                        <li><NavLink to="/" onClick={handleLinkClickCallback} end>Home</NavLink></li>
                        <li><NavLink to="/solutions" onClick={handleLinkClickCallback}>Solutions</NavLink></li>
                        <li><NavLink to="/product" onClick={handleLinkClickCallback}>Products</NavLink></li>
                        <li><NavLink to="/industries" onClick={handleLinkClickCallback}>Industries</NavLink></li>
                        <li><NavLink to="/about" onClick={handleLinkClickCallback}>About</NavLink></li>
                        <li><NavLink to="/contact" onClick={handleLinkClickCallback}>Contact</NavLink></li>
                        <li><NavLink to="/request-demo" onClick={handleLinkClickCallback} className="nav-cta">Request a demo</NavLink></li>
                    </ul>
                </nav>
            )}
        </div>
    );
};

export default React.memo(MobileMenu);
